import React from 'react';
import { IoIosCloseCircleOutline } from '@react-icons/all-files/io/IoIosCloseCircleOutline';

const CloseBtn = () => {

    return (
        <>
            <IoIosCloseCircleOutline fill='#ED8B00'/>
        </>
    )
}

export default CloseBtn